import { HubspotApiService } from '@/services/api/HubspotApiService'
import HubspotIdentityService from '@/services/HubspotIdentityService'
import { LOGOUT, STORE_USER_DETAILS } from '@/store/mutations'

/**
 * Vuex plugin that keeps the HubSpot chat widget identity in sync with the
 * authenticated user. On login/user load it fetches a server-signed visitor
 * token and identifies the user to HubSpot. On logout it resets the widget
 * to an anonymous state.
 *
 * Enabled only when analytics are active (i.e. not in ci/development), matching
 * the same guard used for Segment and other analytics integrations in plugins.js.
 */
export const hubspotIdentityPlugin = (store) => {
  if (['ci', 'development'].includes(process.env.VUE_APP_ENV)) return

  let identifiedEmail = null

  store.subscribe(async (mutation) => {
    if (mutation.type === STORE_USER_DETAILS) {
      const email = store.getters.currentUser && store.getters.currentUser.email
      if (!email || email === identifiedEmail) return

      try {
        const token = await HubspotApiService.fetchVisitorToken()
        HubspotIdentityService.identify(email, token)
        identifiedEmail = email
      } catch (error) {
        // Non-critical — do not interrupt the application on failure
        console.error('[HubSpot] Failed to identify visitor:', error)
      }
    }

    if (mutation.type === LOGOUT) {
      HubspotIdentityService.reset()
      identifiedEmail = null
    }
  })
}
